export const obra = [
  {
    label: "Id",
    name: "idobra",
    type: "INTEGER",
    readonly: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Estado",
    name: "estado",
    type: "STRINGINLIST",
    showOnList: true,
    options: ["Running", "Hold on", "Finalized"],
  },
  {
    label: "Empresa",
    name: "idempresa",
    type: "empresa",
    showOnList: true,
    filterBy: {
      field: "cliente",
      value: () => 1
    },
  },
];
